import "./VerificationBadge.css";

export type VerificationVariant =
  | "blue"
  | "gold"
  | "red"
  | "certified";

interface VerificationBadgeProps {
  variant?: VerificationVariant;
  size?: number | string;
  className?: string;
}

export default function VerificationBadge({
  variant = "blue",
  size,
  className = "",
}: VerificationBadgeProps) {

  const style = size
    ? { width: size, height: size }
    : undefined;

  return (
    <svg
      className={`tl-verification-badge tl-verification-badge--${variant} ${className}`}
      style={style}
      viewBox="0 0 24 24"
    >
      {/* Badge background */}
      <path
        className="tl-verification-badge-bg"
        d="M3.85 8.62a4 4 0 0 1 4.78-4.77
           4 4 0 0 1 6.74 0
           4 4 0 0 1 4.78 4.78
           4 4 0 0 1 0 6.74
           4 4 0 0 1-4.77 4.78
           4 4 0 0 1-6.75 0
           4 4 0 0 1-4.78-4.77
           4 4 0 0 1 0-6.76Z"
      />

      {/* Check */}
      <path
        className="tl-verification-badge-check"
        d="m9 12 2 2 4-4"
      />
    </svg>
  );
}